import I18n from 'i18n-js';
import locales from 'locales.json';

export default function setupLocale() {
  const localeMetaElement = document.getElementById('js-locale');

  if (typeof window.I18n === 'undefined') {
    window.I18n = I18n;
  }

  if (localeMetaElement) {
    window.I18n.defaultLocale = localeMetaElement.dataset.defaultLocale || 'en';
    window.I18n.locale = localeMetaElement.dataset.locale || 'en';
  } else {
    window.I18n.defaultLocale = 'en';
    window.I18n.locale = 'en';
  }

  window.I18n.translations = locales;
}
